import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { Sparkles } from "lucide-react";

/**
 * Generic placeholder shown for screens that are part of the foundation skeleton
 * but will be wired to live data in subsequent components.
 */
export default function PagePlaceholder({ titleKey, subtitle, testId }) {
    const { t } = useI18n();
    return (
        <div className="max-w-3xl fade-up" data-testid={testId || "page-placeholder"}>
            <div className="mb-6">
                <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-foreground" data-testid="page-title">
                    {t(titleKey)}
                </h1>
                {subtitle && (
                    <p className="mt-2 text-base text-muted-foreground">{subtitle}</p>
                )}
            </div>
            <div className="surface-card p-8">
                <div className="flex items-start gap-4">
                    <div className="icon-tile h-12 w-12 shrink-0">
                        <Sparkles className="h-6 w-6" />
                    </div>
                    <div>
                        <p className="text-lg font-semibold text-foreground">{t("common.comingSoon")}</p>
                        <p className="mt-2 text-sm text-muted-foreground">
                            {t("common.comingSoonBody")}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
